// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"77738f5c","703":"66b1e31f","787":"0eafff19"}[chunkId] + ".chunk.js";
};